/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CustomFieldsOptions } from 'app/components/custom-fields/custom-fields.interface';
import { JobsListOptions } from 'app/components/jobs-list/jobs-list.interface';
import { AssetsService } from 'app/core/services/assets/assets.service';
import { CustomFieldGroupService } from 'app/core/services/custom_fields_group/custom_fields_group.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
  selector: 'asset-summary-preview',
  templateUrl: './asset-summary-preview.component.html',
  styleUrls: ['./asset-summary-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection:ChangeDetectionStrategy?.OnPush
})
export class AssetSummaryPreviewComponent implements OnInit, OnChanges {
  @Input() assetId: any = '';
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  object = Object;
  loaded: boolean = false;
  jobsCount: number = 0;
  dataSource: any[] = [];
  assetDetails: any = {};
  displayedColumns: string[] = ['assetName', 'quantity'];
  currency: string;
  digitsInfo: string = '1.2-2';
  customFieldGroups: any = {};
  masterCustomFields: any[] = [];
  isCustomerAccessible: boolean;
  isOrganizationAccessible: boolean;
  isJobAccessible: boolean;
  hasPermissionToNewJob: boolean;

  constructor(
    private dataCollectorService: DataCollectorService,
    private localisationService: LocalisationService,
    private utilityService: UtilityService,
    private router: Router,
    private assetsService: AssetsService,
    private customFieldServie: CustomFieldGroupService,
    private changeDetectorRef: ChangeDetectorRef) {
    this.currency = this.utilityService.companyCurrency;

    this.changeDetectorRef.markForCheck();
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.isCustomerAccessible = this.utilityService.hasModuleAccess('CUSTOMER');
    this.isOrganizationAccessible = this.utilityService.hasModuleAccess('ORGANIZATION');
    this.isJobAccessible = this.utilityService.hasModuleAccess('JOB');
    this.hasPermissionToNewJob = this.utilityService.hasPermission('job.new');
    this.getAssetDetails();
    this.changeDetectorRef.markForCheck();
  }

  closeDrawer(): void {
    this.eventEmitter.emit({ drawerClose: true });
    this.changeDetectorRef.markForCheck();
  }

  getFormattedAddress(address: any): string {
    return this.utilityService.getFormattedAddress(address);
  }

  getAssetDetails(): void {
    this.loaded = false;
    this.dataCollectorService.getData(this.assetsService.getAssetUrl(this.assetId))
      .subscribe(
        (assetDetails: any) => {
          this.assetDetails = assetDetails.data;
          this.loaded = true;
          this.dataSource = assetDetails.data.asset_parts ?? [];
          this.masterCustomFields = assetDetails?.data?.custom_fields;
          this.getCustomFieldGroups();
          this.changeDetectorRef.markForCheck();
        }, (_error: any) => {
          this.loaded = true;
          this.changeDetectorRef.markForCheck();
        });
  }

  getCustomFieldGroups(): void {
    this.customFieldGroups = this.customFieldServie.getCustomFieldGroups(this.masterCustomFields, this.assetDetails.custom_fields);
    this.changeDetectorRef.markForCheck();
  }

  getcustomFieldOptions(data: any): CustomFieldsOptions {
    return {
      data: data,
      displayInColumn: 1,
      extraClass: 'px-0',
      labelAlign: 'Left'
    };
  }

  getAssetStatusValue(status: string): string {
    return status.trim().replaceAll('_', ' ');
  }

  getJobListOptions(): JobsListOptions {
    return {
      url: this.dataCollectorService.baseurl() + '/jobs',
      paramObj: {
        'count': 5,
        'filter.asset': this.assetId,
        'page': 1,
        'sort': 'ASC',
        'sort_by': 'scheduled_start_time'
      }
    };
  }

  jobEventEmitHandler(event: any): void {
    if (!this.utilityService.isEmptyOrUndefined(event?.jobsCount)) {
      this.jobsCount = event.jobsCount;
      this.changeDetectorRef.markForCheck();
    }
  }

  getRedirectLink(): string {
    return this.utilityService.getLink('ASSETS', this.assetDetails.asset_uid);
  }

  createNewJob(event: any): void {
    event.stopPropagation();
    this.router.navigateByUrl('/jobs/new',{
      state:{
        action: 'clone',
        module: 'ASSET',
        uid: this.assetId
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.assetId?.firstChange === false){
      this.getAssetDetails();
      this.changeDetectorRef.markForCheck();
    }
  }
}
